import script from "./language.vue?vue&type=script&setup=true&lang=js"
export * from "./language.vue?vue&type=script&setup=true&lang=js"

import "./language.vue?vue&type=style&index=0&id=b518a6b6&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b518a6b6"]])

export default __exports__